
import { controls } from "../controls";
const membermasteragri = {
  label: "Member Master",
  pageLabel: "Member Master",
  starting: true,
  url: "membermasteragri",
  formActions: { edit: { allow: true } },
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Basic Info",
        uid: "create",
        style: { fontFamily: "verdana" }
      },
    ]
  },
  filter: [

    ...controls.displayText({ tab: "filter", label: "PACS ID", width: "col-sm-1" }),
    ...controls.text({ placeHolder: "PACS ID", name: "pacs_id", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Member ID", width: "col-sm-1" }),
    ...controls.text({ placeHolder: "Member ID", name: "member_id", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Ref ID", width: "col-sm-1" }),
    ...controls.text({ tab: "filter", name: "member_ref_id", width: "col-sm-2", placeHolder: "Ref ID" }),
  ],
  form: [


    ...controls.displayText({ tab: "create", label: "PACS ID", width: "col-sm-1" }),
    ...controls.text({ tab: "create", placeHolder: "PACS ID", name: "pacs_id", width: "col-sm-2" }),


    ...controls.displayText({ tab: "create", label: "Account No", width: "col-sm-1" }),
    ...controls.AccountNumber({
      tab: "create", displayData: {
        producttype_guid: "producttype_guid",
        descn: "account_number_display", guid: 'account_number_guid', balance: "balance", pendingcharges: 'pending_charges', cin: "customer_number", interest_rate: "interest_rate", mobile: "mobile", interest: "interest", minbalance: "min_balance", pan: "pan", total: "total", fd_amount: "fd_amount", aadhar: "aadhaar", mat_amount: "maturity_amount", opendate: "opendate", expdate: "expdate", closedate: "closedate", intdate: "intdate", withdrawable: "withdrawable", product_code: "product_code",
        RiskCategory: "RiskCategory", custtype: "custtype", kycduedate: "kycduedate", kycdone: "kycdone", cashpaymentday: "cashpaymentday", cashreceiptday: "cashreceiptday", cashpaymentweek: "cashpaymentweek", cashreceiptweek: "cashreceiptweek", qtrreceipts: "qtrreceipts", qtrpayments: "qtrpayments", cashpaymentyear: "cashpaymentyear", cashreceiptyear: "cashreceiptyear", openbyuser: "openbyuser", closing_charges: "entered_charges"
      },
      onLeave: ["checkPAN", "checkMobile", "checkSMS", "checkAADHAAR", "checkLoans"],
    }),
    ...controls.showData({ tab: "create", data: "account_number_display", width: "col-sm-3" }),

    ...controls.displayText({ tab: "create", label: "Ref ID", width: "col-sm-1" }),
    ...controls.text({ tab: "create", name: "member_ref_id", width: "col-sm-2", placeHolder: "Ref ID" }),


    {
      widths: "col-sm-12",
      tab: "create",
      title: "Land Records",
      subComponents: [
        ...controls.displayText({ tab: "create", label: "GAT/Survey No", width: "col-sm-1" }),
        ...controls.text({ tab: "create", placeHolder: "गट नंबर", name: "gat_no", width: "col-sm-2" }),

        ...controls.displayText({ tab: "create", label: "7/12 Number", width: "col-sm-1" }),
        ...controls.text({ tab: "create", placeHolder: "7/12 Number", name: "seven_twelve_no", width: "col-sm-2" }),

        // land type - jirayat/bagayat/tari/warkas/other, borewell - check, 7/12 details from https://bhulekh.mahabhumi.gov.in/

        // Show the above in table below.
      ]
    }
  ],
  history: {
    perPage: 10,
    reportHeader: "Deposit Accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "PACS ID",
        accessor: "pacs_id"
      },
      {
        Header: "Account Number",
        accessor: "account_number",
      },
      {
        Header: "Member ID",
        accessor: "member_id",
        width: 150
      },
      {
        Header: "Member Name",
        accessor: "member_name"
      },
      {
        Header: "Reference ID",
        accessor: "ref_id"
      }
    ]
  }
};

export default membermasteragri;